export const SCANNER_BASE_URL = "https://localhost:53052";

export const SCANNER_PREFERENCE_KEY = "ambirScanWebConnect.preferredScanner";

/**
 * Fixed for US driver's licenses. 300 DPI + Color is Ambir's documented
 * recommendation for the dense PDF_417 on the back of a license.
 * `transferMode` is deliberately omitted so the desktop app's native-transfer
 * default applies — buffered transfer is documented to shear pages and
 * silently ignore auto-crop on several drivers.
 */
export const SCAN_PARAMS = {
  resolution: 300,
  colorMode: "Color",
  duplexMode: "DuplexLongEdge",
  pageSize: "Auto",
  autoRotate: false,
  autoDeskew: false,
  autoCrop: false,
  outputFormat: "png",
  barcodeReadingEnabled: true,
  barcodeFilterLevel: "Normal",
  ocrEnabled: false,
  requestTimeoutSeconds: 0,
};
